import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { IQueryPageRequest } from "@main/reporting.v3/core/reporting-models";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { XlsExportService } from "@main/reporting.v3/api/xls-exporting.service";

@Injectable()
export class WidgetGridXlsExportingService extends XlsExportService {
    readonly url = "api/reporting3/widget/grid/data";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async getXlsExportingFile(dashboardId: string, queryPageRequest: IQueryPageRequest): Promise<Blob> {
        return this.handle(this.http.post(`${this.url}/${dashboardId}/xls-export`, queryPageRequest, { responseType: "blob" }));
    }

    public async generateXls(dashboardId: string, fileName: string, queryPageRequest: IQueryPageRequest): Promise<void> {
        this.performDownload(fileName, await this.getXlsExportingFile(dashboardId, queryPageRequest));
    }
}